import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import DocumentTitle from 'react-document-title'

import '../stylus/app.styl'

import config from '../config.js'
import { navRoutes } from './routes.js'
import SlideMenuContainer from '../navigation/SlideMenuContainer.js'
import { closeNavMenu } from '../navigation/actions.js'
import OfflineBanner from '../offline/offline.js'
import { PageSpinner, GenericError } from '../components/index.js'
import { initializeUserAuth, getExtraUserInfo } from '../auth/actions.js'
import { LoginRequired } from '../auth/requireLogin.js'
import { hasAuthCheckFinished, isLoggedIn, selectLoginError } from '../auth/reducer.js'
import Toasts from '../notifications/Toasts'
import { selectIsRequestPending } from '../util/index'
import { getAppStatus } from '../appStatus/actions'

const navLinks = navRoutes.map(r => ({ to: r.path, label: r.title }))

class App extends Component {
  componentDidMount () {
    this.props.initializeUserAuth()    
  }
  render () {
    let { closeNavMenu, children, loginFinished, loginError, extraInfoPending, appStatusPending } = this.props
    if (loginError) return <GenericError error={loginError} />
    if (!loginFinished) return <PageSpinner  title='Authenticating...'/>
    if (extraInfoPending) return <PageSpinner title='Requesting additional user data, this may take a minute...'/>
    if (appStatusPending) return <PageSpinner title='Checking Status of connected apps...' />
    return (
      <DocumentTitle title={config.appName}>
        <div className='u-full-height'>
          <OfflineBanner />
          <SlideMenuContainer
            title={config.appName}
            description={config.appFullName}
            navLinks={navLinks}
            onClose={closeNavMenu}
            env={config.env}>
            <div className='app-container m12-sm'>
              <LoginRequired>
                {children}
              </LoginRequired>
              <Toasts />
            </div>
          </SlideMenuContainer>
        </div>
      </DocumentTitle>
    )
  }
}

export { App }
export default withRouter(connect(state => ({
  appStatusPending: selectIsRequestPending(state, getAppStatus),
  extraInfoPending: selectIsRequestPending(state, getExtraUserInfo),
  loginError: selectLoginError(state),
  loginFinished: hasAuthCheckFinished(state),
  isLoggedIn: isLoggedIn(state)
}), { closeNavMenu, initializeUserAuth, getExtraUserInfo, getAppStatus })(App))



// WEBPACK FOOTER //
// ./client/src/root/App.js